/**
 * Rapier3D bootstrap. Isolated here so the WASM init happens exactly once and
 * nothing else in the codebase has to know it is async.
 *
 * NOTE for session 1: the character controller belongs in this directory
 * (`physics/character.ts`) and is deliberately NOT written yet — how Rosalie
 * moves is a game-feel decision, which is session 1's whole job.
 */

import RAPIER from '@dimforge/rapier3d-compat';

export type { RAPIER };

let initialised = false;

export async function initPhysics(): Promise<typeof RAPIER> {
  if (!initialised) {
    await RAPIER.init();
    initialised = true;
  }
  return RAPIER;
}

export interface PhysicsWorld {
  readonly rapier: typeof RAPIER;
  readonly world: RAPIER.World;
  /** Advance one fixed step. Timestep is owned by the sim loop, not by Rapier. */
  step(dt: number): void;
}

export async function createPhysicsWorld(gravityY = -9.81): Promise<PhysicsWorld> {
  const rapier = await initPhysics();
  const world = new rapier.World({ x: 0, y: gravityY, z: 0 });

  return {
    rapier,
    world,
    step(dt: number): void {
      // Keep Rapier's integration step locked to our fixed timestep so the
      // simulation stays deterministic (spec §1).
      world.timestep = dt;
      world.step();
    },
  };
}
